import type { Odds as OddsType } from '@ps/isp-web-services-types';
import classNames from 'clsx';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Odds } from '@swf/sports/components';

import { TXTWCL_Previous_Odds } from './PreviousPrice.messages.json';
import styles from './PreviousPrice.scss';

interface Props {
  odds: OddsType;
  isSelected?: boolean;
}

const PreviousPrice: React.FC<Props> = ({ odds, isSelected }) => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <span
      aria-label={formatMessage(TXTWCL_Previous_Odds)}
      className={classNames(styles.previousPrice, {
        [styles.selected]: isSelected
      })}
    >
      <Odds {...odds} />
    </span>
  );
};

export default PreviousPrice;
